import { render, staticRenderFns } from "./ActivationBriefRouterView.vue?vue&type=template&id=6a23b8b0&"
import script from "./ActivationBriefRouterView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports